var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "hourglass_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.333 55.333V42.466L27.986 32 13.333 21.534V8.667H8.667V4h46.666v4.667h-4.666v12.867L36.015 32l14.652 10.466v12.867h4.666V60H8.667v-4.667z",
    clipRule: "evenodd"
  })));
};
export { SvgHourglass as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjMzMzQgNTUuMzMzM1Y0Mi40NjU5TDI3Ljk4NTYgMzJMMTMuMzMzNCAyMS41MzQxVjguNjY2NjdIOC42NjY3NVY0SDU1LjMzMzRWOC42NjY2N0g1MC42NjY3VjIxLjUzNDFMMzYuMDE0NiAzMkw1MC42NjY3IDQyLjQ2NTlWNTUuMzMzM0g1NS4zMzM0VjYwSDguNjY2NzVWNTUuMzMzM0gxMy4zMzM0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";